/**
 * @author Ivan Torres
 */
import { __read } from "tslib";
import { useMemo } from 'react';
import { useTheme } from '../theme';
import _buildUtils from './_buildUtils';
import useMemoizedStyletron from './useMemoizedStyletron';
var useStyle = function () {
    var ctx = useTheme();
    var _a = __read(useMemoizedStyletron(), 1), styletronCSS = _a[0];
    return useMemo(function () { return _buildUtils(ctx, styletronCSS); }, [ctx, styletronCSS]);
};
export default useStyle;
